import { Settings } from "./Settings";

export * from "./Settings";
export default Settings;
